const purchaseTabs = document.querySelectorAll('.purchase-process-02__tab');
const optionalServicePriceEl = document.querySelector('.optional-service-price');
const totalPriceEl = document.querySelector('.order-final');
const deliveryPriceEl = document.querySelector('.delivery-price');
const totalPriceText = document.querySelector('.order-final__price');
const deliveryPriceText = document.querySelector('.delivery-price .order-table__right strong');
const totalPriceExcludingTaxEl = document.querySelector('.total-price-excluding-vat');
const taxEl = document.querySelector('.vat-ddv');
let euro;
let totalPriceData;
let deliveryPrice;
let taxPercentage;
let tax;
let totalPriceExcludingTax;
if (totalPriceEl) {
  euro = totalPriceEl.dataset.euro;
  totalPriceData = totalPriceEl.dataset.price.replace(',', '.');
  if (deliveryPriceEl) {
    deliveryPrice = deliveryPriceEl.dataset.deliveryprice || 0;
  }
  taxPercentage = totalPriceEl.dataset.tax;
}

const updatePrices = () => {
  totalPriceEl.dataset.price = totalPriceData.toFixed(2);
  deliveryPriceEl.dataset.deliveryprice = deliveryPrice.toFixed(2);
  totalPriceText.innerText = new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(totalPriceData);
  deliveryPriceText.innerText = new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(deliveryPrice);
  tax = totalPriceData * (parseFloat(taxPercentage) / (100 + parseFloat(taxPercentage)));
  totalPriceExcludingTax = totalPriceData - tax;
  totalPriceExcludingTaxEl.innerText = new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(totalPriceExcludingTax);
  taxEl.innerText = new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(tax);
};

const updateServices = (availableServices) => {
  let optionsHidden = true;
  availableServices.forEach((availableService) => {
    const service = document.querySelector(`.purchase-process-02__optional [data-id="${availableService.id}"]`);
    service.querySelector('input').checked = availableService.checked;
    service.classList.toggle('hidden', availableService.hidden);
    if (!availableService.checked) {
      deliveryPriceEl.querySelectorAll(`[data-id="${availableService.id}"]`).forEach((el, i) => {
        if (!i) {
          deliveryPrice = parseFloat(deliveryPrice) - parseFloat(availableService.price);
          totalPriceData = parseFloat(totalPriceData) - parseFloat(availableService.price);
        }
        el.remove();
      });
      updatePrices();
    }
    if (!availableService.hidden) {
      optionsHidden = false;
    }
  });
  document.querySelector('.purchase-process-02__optional').classList.toggle('hidden', optionsHidden)
};

const axiosAddRemoveDeliveryFromCart = (formData, purchaseTab) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'addRemoveDeliveryFromCart');
  formDataInput.append('inputs', JSON.stringify(formData));
  formDataInput.append('id', localData.id);
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // success
        purchaseTabs.forEach((tabEl) => {
          // eslint-disable-next-line no-param-reassign
          tabEl.style.pointerEvents = 'auto';
        });
        // eslint-disable-next-line no-param-reassign
        purchaseTab.dataset.key = response.data.data.key;
        updateServices(response.data.data.available_services);
        const disclaimerText = document.querySelector('.purchase-process-02__delivery .disclaimer-text');
        if (disclaimerText) {
          disclaimerText.classList.toggle('hidden', purchaseTab.dataset.deliveryName !== 'standard_delivery');
        }
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

purchaseTabs.forEach((purchaseTab, index) => {
  purchaseTab.addEventListener('click', () => {
    const activeTab = document.querySelector('.purchase-process-02__tab.is-active');
    const activeKey = activeTab.dataset.key;
    if (activeKey !== purchaseTab.dataset.key) {
      const allActiveTab = document.querySelectorAll('.purchase-process-02__tab.is-active');
      const activeContent = document.querySelectorAll('.purchase-process-02__tabs-content.is-active');

      allActiveTab.forEach((tabEle) => {
        tabEle.classList.remove('is-active');
      });

      activeContent.forEach((contentEle) => {
        contentEle.classList.remove('is-active');
      });

      const tabParent = purchaseTab.closest('.purchase-process-02__delivery');
      const tabContentParent = (windowWidth() > breakpointSm ? tabParent.querySelector('.purchase-process-02__delivery-tabs-wrapper') : tabParent.querySelector('.purchase-process-02__tabs'));
      const targetContent = tabContentParent.querySelectorAll('.purchase-process-02__tabs-content')[index];
      purchaseTab.classList.add('is-active');
      targetContent.classList.add('is-active');

      const activeVariationId = activeTab.dataset.variationid;
      const activeProductId = activeTab.dataset.productid;
      const newVariationId = purchaseTab.dataset.variationid;
      const newProductId = purchaseTab.dataset.productid;
      const activeId = activeVariationId || activeProductId;
      const newId = newVariationId || newProductId;
      const activePrice = parseFloat(activeTab.dataset.price.replace(',', '.')).toFixed(2);
      const newPrice = parseFloat(purchaseTab.dataset.price.replace(',', '.')).toFixed(2);
      const newText = purchaseTab.querySelector('.tab-title').innerText;
      const formData = {
        product_id: newProductId,
        variation_id: newVariationId,
        key_to_delete: activeKey,
      };
      activeTab.dataset.key = '';
      totalPriceData = parseFloat(totalPriceData) - parseFloat(activePrice) + parseFloat(newPrice);
      deliveryPrice = parseFloat(deliveryPrice) - parseFloat(activePrice) + parseFloat(newPrice);
      deliveryPriceEl.querySelectorAll(`[data-id="${activeId}"]`).forEach((el) => el.remove());
      deliveryPriceEl.insertAdjacentHTML(
        'afterbegin',
        `<div class="order-table__left" data-id="${newId}">${newText}</div><div class="order-table__right" data-id="${newId}">${new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(newPrice)}</div>`,
      );
      updatePrices();

      purchaseTabs.forEach((tabEl) => {
        // eslint-disable-next-line no-param-reassign
        tabEl.style.pointerEvents = 'none';
      });
      axiosAddRemoveDeliveryFromCart(formData, purchaseTab);
    }
  });
});

const addRemoveOptionalService = (serviceId, serviceText, servicePrice, checked) => {
  if (checked) {
    deliveryPriceEl.querySelectorAll(`[data-id="${serviceId}"]`).forEach((el) => {
      el.remove();
    });
  } else {
    deliveryPriceEl
      .querySelector('div:nth-last-child(2)')
      .insertAdjacentHTML(
        'beforebegin',
        `<div class="order-table__left" data-id="${serviceId}">${serviceText}</div><div class="order-table__right" data-id="${serviceId}">${new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(servicePrice)}</div>`,
      );
  }
  totalPriceData = checked ? parseFloat(totalPriceData) - parseFloat(servicePrice) : parseFloat(totalPriceData) + parseFloat(servicePrice);
  deliveryPrice = checked ? parseFloat(deliveryPrice) - parseFloat(servicePrice) : parseFloat(deliveryPrice) + parseFloat(servicePrice);
  totalPriceEl.dataset.price = totalPriceData.toFixed(2);
  deliveryPriceEl.dataset.deliveryprice = deliveryPrice.toFixed(2);
  totalPriceText.innerText = new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(totalPriceData);
  deliveryPriceText.innerText = new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(deliveryPrice);
};

const debounceRequest = (func, timeout = 200) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), timeout);
  };
};

const axiosAddRemoveServiceFromCart = (formData) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'addRemoveServiceFromCart');
  formDataInput.append('inputs', JSON.stringify(formData));
  formDataInput.append('id', localData.id);
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // success
        console.log(response);
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

const debounceAxiosAddRemoveServiceFromCart = debounceRequest((formData) => axiosAddRemoveServiceFromCart(formData));

const handleCheckboxDependencies = (checkbox) => {
  let removedId = null;
  const serviceName = checkbox.dataset.service;
  const checkboxPairs = {
    'carry_in': 'carry_in_help',
    'carry_in_help': 'carry_in',
    'carry_out': 'carry_out_help',
    'carry_out_help': 'carry_out'
  };

  if (checkboxPairs[serviceName]) {
    const dependentCheckbox = document.querySelector(`.optional-checkbox:not(.hidden)[data-service="${checkboxPairs[serviceName]}"]`);
    if (dependentCheckbox) {
      const dependentInput = dependentCheckbox.querySelector('input[type="checkbox"]');
      if (dependentInput.checked) {
        dependentCheckbox.querySelector('.checkbox__label').click();
        removedId = dependentCheckbox.dataset.id;
      }
    }
  }

  return removedId;
};

attachEvent('.optional-checkbox .checkbox__label', 'click', (ev) => {
  const checkbox = ev.target.closest('.optional-checkbox');
  const serviceId = checkbox.dataset.id;
  const serviceText = checkbox.querySelector('.checkbox__text').innerText;
  const serviceChecked = checkbox.querySelector('input[type="checkbox"]').checked;
  const servicePrice = checkbox.dataset.price;
  const removedId = handleCheckboxDependencies(checkbox);
  const formData = {
    service_id: serviceId,
    checked: serviceChecked,
    removedId
  };
  addRemoveOptionalService(serviceId, serviceText, servicePrice, serviceChecked);
  debounceAxiosAddRemoveServiceFromCart(formData);
});
